import React from "react";
import "./howto.css"; // Optional: Falls du Styling möchtest
import Footer from "./Footer";

const HowTo = () => {
  return (
    <div className="howto-container">
      <h1 className="howto-title">Tutorial: How to install Pokémon featured TFT</h1>
      
      <div className="video-container">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/yI6Zotee6C8"
          title="YouTube Video Player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <div className="howto-content">
        <p><strong>Pokémon Unite China: New Autochess Mode – How to Play It!</strong></p>
        <p>
          Fans of Pokémon and autochess games like Teamfight Tactics or Dota Auto Chess  
          have been waiting for this. Now there's a TFT mode in Pokémon Unite!  
          Unfortunately, it's currently only available in the **Chinese version**.
        </p>

        <p><strong>How to Install Pokémon Unite China on PC or Mobile:</strong></p>
        <ul>
          <li>Download an emulator (e.g., Mumu Player or Bluestacks).</li>
          <li>Visit the official website <a href="https://unite.qq.com" target="_blank" rel="noopener noreferrer">unite.qq.com</a> and download the game.</li>
          <li>Create a WeChat account (required for login).</li>
          <li>Install the game & connect via WeChat.</li>
          <li>Reach level 6 or 7 to unlock the TFT mode.</li>
        </ul>

        <p><strong>How Does the Pokémon Autochess Mode Work?</strong></p>
        <ul>
          <li>Chessboard-like battlefield: Strategically place your Pokémon.</li>
          <li>Automatic battles: Pokémon fight in rounds against other players.</li>
          <li>Evolutions & items: Combining three of the same Pokémon upgrades them.</li>
          <li>Synergies & meta: Certain Pokémon combinations are particularly strong.</li>
        </ul>

        <p><strong>Exclusive Website for Translations & Meta-Teams</strong></p>
        <p>
          Since the game is only available in Chinese, a **fan-made website** provides translations  
          for synergies, items, and meta-teams. There, you can find tips on building the best Pokémon  
          combos and optimizing your strategy.
        </p>

        <p><strong>🎮 Conclusion:</strong></p>
        <p>
          If you want to experience Pokémon Autochess, you can play the mode with some effort  
          despite the language barrier. The community has already created tools to make the  
          game more accessible.  
        </p>
        <p>
          Would you like to see this mode in the **global version** of Pokémon Unite?  
          Let us know in the comments!
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default HowTo;
